module.exports = __webpack_public_path__ + "img/trufence_diagram_step1.6ed6e4a6.svg";